import ViewModelCore from "./ViewModel";

export default class ComponenteViewModel extends ViewModelCore {
    constructor () {
        super();
        this.CodigoEmpresa = undefined;
        this.CodigoLinhaId = undefined;
        this.CodigoProduto = undefined;
        this.CodigoSistema = undefined;
        this.ComponenteTipo = undefined;
        this.Critica1 = undefined;
        this.Critica2 = undefined;
        this.Critica3 = undefined;
        this.Critica4 = undefined;
        this.Critica5 = undefined;
        this.DescricaoAcabamentoFrente = undefined;
        this.DescricaoAcabamentoVerso = undefined;
        this.DescricaoCapaExterna = undefined;
        this.DescricaoCapaInterna = undefined;
        this.DescricaoCoresFrente = undefined;
        this.DescricaoCoresVerso = undefined;
        this.DescricaoMaterial = undefined;
        this.DescricaoMedidas = undefined;
        this.DescricaoOnda = undefined;
        this.DescricaoOutrasEmbalagensEspecificas = undefined;
        this.DescricaoPapelOnda = undefined;
        this.EmbalagemEspecificaCaixaColetiva = undefined;
        this.EmbalagemEspecificaFilmeEncolhivel = undefined;
        this.EmbalagemEspecificaPalete = undefined;
        this.EmbalagemEspecificaPapelEmbrulho = undefined;
        this.EmpresaId = undefined;
        this.FSC = undefined;
        this.Id = undefined;
        this.Legislacao = undefined;
        this.Lote = undefined;
        this.NomeCorFrente = undefined;
        this.NomeCorVerso = undefined;
        this.NumeroAltura = undefined;
        this.NumeroAlturaTampa = 0;
        this.NumeroComponente = undefined;
        this.NumeroComprimento = undefined;
        this.NumeroGramaturaCapaExterna = undefined;
        this.NumeroGramaturaCapaInterna = undefined;
        this.NumeroGramaturaPapelOnda = undefined;
        this.NumeroLargura = undefined;
        this.NumeroRepeticoes = undefined;
        this.ObservacoesGerais = undefined;
        this.OrcamentoComponenteId = undefined;
        this.produtoId = undefined;
        this.QuantidadeCaixaColetiva = undefined;
        this.QuantidadeCoresFrente = undefined;
        this.QuantidadeCoresVerso = undefined;
        this.QuantidadeFilmeEncolhivel = undefined;
        this.QuantidadeOutros = undefined;
        this.QuantidadePalete = undefined;
        this.QuantidadePapelEmbrulho = undefined;
        this.Sequencia = undefined;
        this.SistemaTexto = '';
        this.DescricaoSistema = 0;
        this.NumeroPrototipoComponenteTipo = undefined;
        this.NumeroPrototipoSistema = undefined;
        this.SistemaId = undefined;
        this.ProdutoMaterialId = undefined;
        this.ProdutoSistemaId = undefined;
        this.NumeroPrototipoMaterial = undefined;
        this.ConformeUnidadeId = undefined;
        this.SistemaUnidadeId = undefined;
        this.ProdutoMaterialLista = undefined;
        this.ProdutoSitemaLista = undefined;
    }
    get ComponenteTipoTexto(){
        switch (this.ComponenteTipo)
        {
            case 0:
                return "Tampa";
            case 1:
                return "Fundo";
            case 2:
                return "Peça Única";
            case 3:
                return "Cartuchos";
            case 4:
                return "Diversos";
            case 5:
                return "Suportes";
            case 6:
                return "Sacola";
            case 7:
                return "Luva";
            default :
                return "";
        }
    }

    get DescricaoAcabamentoFrenteTexto(){
        switch (this.DescricaoAcabamentoFrente)
        {
            case 0:
                return "Conforme amostra";
            case 1:
                return "Natural";
            case 2:
                return "Verniz";
            case 3:
                return "Verniz Fosco";
            case 4:
                return "Verniz Soft Touch";
            case 5:
                return "Verniz UV";
            case 6:
                return "Plastificado";
            case 7:
                return "Plastificado Fosco";
            case 8:
                return "Verniz UV Localizado"
            default:
                return "";

        }
    }

    get DescricaoMedidasTexto(){
        switch (this.DescricaoMedidas)
        {
            case 0:
                return "Conforme Produto";
            case 1:
                return "Conforme protótipo";
            case 2:
                return "Conforme planta";
            case 3:
                return "Conforme arquivo digital";
            case 4:
                return "Conforme amostra";
            case 5:
                return "Conforme fundo";
            default:
                return "";
        }
    }
    get DescricaoCoresFrenteTexto(){
        switch (this.DescricaoCoresFrente)
        {
            case 0:
                return "SEM IMPRESSÃO";
            case 1:
                return "1 COR";
            case 2:
                return "2 CORES";
            case 3:
                return "3 CORES";
            case 4:
                return "4 CORES";
            case 5:
                return "5 CORES";
            case 6:
                return "6 CORES";
            case 7:
                return "CONFORME AMOSTRA";
            case 8:
                return "CONFORME ARQUIVO DIGITAL";
            case 9:
                return "CONFORME PLANTA";
            default:
                return "";
        }
    }
    get DescricaoCoresVersoTexto(){
        switch (this.DescricaoCoresVerso)
        {
            case 0:
                return "SEM IMPRESSÃO";
            case 1:
                return "1 COR";
            case 2:
                return "2 CORES";
            case 3:
                return "3 CORES";
            case 4:
                return "4 CORES";
            case 5:
                return "5 CORES";
            case 6:
                return "6 CORES";
            case 7:
                return "CONFORME AMOSTRA";
            case 8:
                return "CONFORME ARQUIVO DIGITAL";
            case 9:
                return "CONFORME PLANTA";
            default:
                return "";
        }
    }

    get DescricaoAcabamentoVersoTexto(){
        switch (this.DescricaoAcabamentoVerso)
        {
            case 0:
                return "Conforme amostra";
            case 1:
                return "Natural";
            case 2:
                return "Verniz";
            case 3:
                return "Verniz Fosco";
            case 4:
                return "Verniz Soft Touch";
            case 5:
                return "Verniz UV";
            case 6:
                return "Plastificado";
            case 7:
                return "Plastificado Fosco";
            case 8 :
                return "Verniz UV Localizado"
            default:
                return "";
        }
    }

    get DescricaoMaterialTexto(){
        switch (this.DescricaoMaterial)
        {
            case 0:
                return "Face simples/Chapa";
            case 1:
                return "Cartão";
            case 2:
                return "Formato";
            case 3:
                return "Empastado";
            case 4:
                return "Conforme amostra";
            case 5:
                return "Conforme planta";
            case 6:
                return "Material a desenvolver";
            case 7:
                return "Conforme protótipo número";
            case 8:
                return "PVC";
            default:
                return "";
        }
    }
    get DescricaoCapaExternaTexto(){
        switch (this.DescricaoCapaExterna)
        {
            case 0:
                return "Cartão duplex";
            case 1:
                return "Cartão";
            case 2:
                return "Cartão triplex";
            case 3:
                return "Papel miolo";
            case 4:
                return "Test Liener";
            case 5:
                return "Papel Kraft";
            case 6:
                return "Duplex sem coating";
            case 7:
                return "Semi Kraft";
            case 8:
                return "Papel off-set";
            default:
                return "";
        }
    }
    get DescricaoPapelOndaTexto(){
        switch (this.DescricaoPapelOnda)
        {
            case 0:
                return "Cartão duplex";
            case 1:
                return "Cartão";
            case 2:
                return "Cartão triplex";
            case 3:
                return "Papel miolo";
            case 4:
                return "Test Liener";
            case 5:
                return "Papel Kraft";
            case 6:
                return "Duplex sem coating";
            case 7:
                return "Semi Kraft";
            case 8:
                return "Papel off-set";
            default:
                return "";
        }
    }
    get DescricaoCapaInternaTexto(){
        switch (this.DescricaoCapaInterna)
        {
            case 0:
                return "Cartão duplex";
            case 1:
                return "Cartão";
            case 2:
                return "Cartão triplex";
            case 3:
                return "Papel miolo";
            case 4:
                return "Test Liener";
            case 5:
                return "Papel Kraft";
            case 6:
                return "Duplex sem coating";
            case 7:
                return "Semi Kraft";
            case 8:
                return "Papel off-set";
            default:
                return "";
        }
    }
    get DescricaoOndaTexto(){
        switch (this.DescricaoOnda)
        {
            case 0:
                return "Onda E";
            case 1:
                return "Onda B";
            case 2:
                return "Onda F";
            case 3:
                return "Onda Dupla";
            case 4:
                return "Conforme amostra";
            case 5:
                return "Conforme planta";
            default:
                return "";
        }
    }
    get ColunaMedidas(){
        if(!this.NumeroComprimento && !this.NumeroLargura && !this.NumeroAltura && !this.NumeroAlturaTampa) return this.DescricaoMedidasTexto
        return `${this.NumeroComprimento} x ${this.NumeroLargura} x ${this.NumeroAltura} x ${this.NumeroAlturaTampa || '0'}`
    }
}

var teste = new ComponenteViewModel()
teste.teste
